import { Component, Input } from '@angular/core';
import { ISot } from '../../../cereri.interface';

@Component({
    selector: 'app-spouse',
    templateUrl: './spouse.component.html',
    styleUrls: ['./spouse.component.scss']
})
export class SpouseComponent {
    @Input() spouse!: ISot;
}
